module.exports = {
  greetingCard: {
    id: "greetingCard",
    title: "Greeting Card",
    subtitle: "Expression of Sentiment",
    needShipping: true,
    single: true,
    thumbnail:
      "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_560/v1556697964/mondaybee/assets/2019_mothers_day_card_1.jpg",
    shortDesc: "Fond memories in a simple card",
    features: [
      "Folded A3 card stock",
      "A4 customized photo mosaic on the front"
    ],
    desc: [
      "This large photo mosaic card allows you to thank your love ones in the most heartmelting way."
    ],
    weight: 0.1,
    images: [
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/v1556697964/mondaybee/assets/2019_mothers_day_card_1.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1556697964/mondaybee/assets/2019_mothers_day_card_1.jpg",
        alt: "2019 Mother's Day Card with flower by Mondaybee",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/v1556699117/mondaybee/assets/2019_mothers_day_card_2.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1556699117/mondaybee/assets/2019_mothers_day_card_2.jpg",
        alt: "2019 Mother's Day Card by Mondaybee",
        width: 1080,
        height: 720
      }
    ]
  },
  faceMounting: {
    id: "faceMounting",
    title: "Face Mounting",
    subtitle: "Luxury Home Décor",
    needShipping: true,
    single: false,
    thumbnail:
      "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_560/v1548230915/mondaybee/assets/facemounting.jpg",
    shortDesc: "Premium display quality",
    features: [
      "Premium Photo Paper",
      "Front Kuraray - Super Clean Acrylic 2.5 mm",
      "Back Black Board Acrylic 2.5 mm",
      "Black Aluminum Hanging System",
      "Crystal Polishing"
    ],
    desc:
      "This fine craft carefully made in Hong Kong will give your home a luxurious touch. The super clean acrylic and crystal polishing allow your moments to be exhibited in the most sophisticated condition.",
    images: [
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/v1548208211/mondaybee/assets/Face_Mounting_1.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1548208211/mondaybee/assets/Face_Mounting_1.jpg",
        alt: "Face Mounting",
        width: 1080,
        height: 717
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1548208207/mondaybee/assets/Face_Mounting_2.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1548208207/mondaybee/assets/Face_Mounting_2.jpg",
        alt: "Face Mounting at Home",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1548208210/mondaybee/assets/Face_Mounting_Close_Up.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1548208210/mondaybee/assets/Face_Mounting_Close_Up.jpg",
        alt: "Face Mounting Close up",
        width: 1080,
        height: 718
      }
    ],
    optionTitle: "size",
    options: [
      {
        id: "a1",
        name: "A1 (833mm x 595mm)",
        weight: 5
      },
      {
        id: "a2",
        name: "A2 (595mm x 425mm)",
        weight: 2.5
      }
    ]
  },
  canvasPrint: {
    id: "canvasPrint",
    title: "Canvas Print",
    subtitle: "Stylish Home Decor",
    needShipping: true,
    single: false,
    thumbnail:
      "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto:good,w_560/v1552372663/mondaybee/assets/CanvasPrint2.jpg",
    shortDesc: "Superior display quality",
    features: [
      "A1 Rolled Canvas Print",
      "Fine Art Water Resistant Canvas ",
      "Superior-quality Coatings",
      "Easy-to-install Magnetic Wooden Hanger Frame (optional)"
    ],
    desc: [
      "This superiorly durable rolled canvas print will style up your home. The authentic canvas allows you to present your moments almost like hand painted art. The unmounted print can be fold and rolled for transport and easy storage. It also allows you to mount or frame it in your own way. If a quick yet stylish set-up is what you are searching for, you can order a magnetic wooden hanger frame along with the print with an additional cost."
    ],
    images: [
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1552372663/mondaybee/assets/CanvasPrint2.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1552372663/mondaybee/assets/CanvasPrint2.jpg",
        alt: "Canvas Print Close Up",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1542194565/mondaybee/assets/CanvasPrint1.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1541576000/mondaybee/assets/CanvasPrint1.jpg",
        alt: "Canvas Print in Apartment",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1542194565/mondaybee/assets/CanvasPrint3.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1541576000/mondaybee/assets/CanvasPrint3.jpg",
        alt: "Canvas Print in Apartment",
        width: 720,
        height: 1080
      }
    ],
    optionTitle: "option",
    options: [
      {
        id: "woodenFrame",
        name: "Include magnetic wooden hanger frame",
        weight: 1.2
      },
      {
        id: "noFrame",
        name: "Without frame",
        weight: 0.8
      }
    ]
  },
  timeCapsule: {
    id: "timeCapsule",
    title: "Time Capsule",
    subtitle: "Journey to the Past",
    needShipping: true,
    single: false,
    thumbnail:
      "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_560/v1541576000/mondaybee/assets/timecapsule1.jpg",
    shortDesc: "Your memories in one place.",
    features: [
      "A2 High quality printed poster",
      "Cardboard poster tube",
      "High definition softcopy (7000 x 5000 px)"
    ],
    desc: [
      "This time capsule allows you to seal all your together moments beautifully printed on a high-quality mosaic poster. You can write on the back of the poster with our thoughtfully designed reflection template. You can even enclose a few more important items in the capsule, set a special date to reopen the capsule, and experience a memorable time travel together. It is truly a special gift to your dear ones or even to yourself.",
      `The full package is a ready-to-go gift. After you have created the mosaic with us and are satisfied with the preview, we will do the final quality check and have the whole package carefully prepared and mailed to you.`
    ],
    images: [
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1542708973/mondaybee/assets/Time_Capsule_Full_Package.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1542708973/mondaybee/assets/Time_Capsule_Full_Package.jpg",
        alt: "time capsule poster in cafe",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1542194565/mondaybee/assets/Time_Capsule_Poster_Close_up.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1541576000/mondaybee/assets/Time_Capsule_Poster_Close_up.jpg",
        alt: "close up of the time capsule poster",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1542703038/mondaybee/assets/Writing_on_the_back_of_2018_Time_Capsule_Poster.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1541576000/mondaybee/assets/Writing_on_the_back_of_2018_Time_Capsule_Poster.jpg",
        alt: "Writing on the back of our Time Capsule (2018 edition)",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto/l_mondaybee:assets:watermark,g_south_east,x_35,y_30/v1542339077/mondaybee/assets/Poster_Dimensions.png",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1541576000/mondaybee/assets/Poster_Dimensions.png",
        alt: "dimensions",
        width: 1080,
        height: 720
      }
    ],
    optionTitle: "back side",
    options: [
      {
        id: "empty",
        name: "None",
        image:
          "https://res.cloudinary.com/nrator/image/upload/v1548225621/mondaybee/assets/emptyback.jpg",
        weight: 0.8
      },
      {
        id: "2018",
        name: "2018",
        image:
          "https://res.cloudinary.com/nrator/image/upload/v1541644816/mondaybee/assets/posterBack.jpg",
        weight: 0.8
      }
    ]
  },
  postcards: {
    id: "postcards",
    title: "Postcards",
    subtitle: "A Mailable Past",
    needShipping: true,
    single: false,
    thumbnail:
      "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_560/v1552375451/mondaybee/assets/Postcards.jpg",
    shortDesc: "A5 Postcards",
    features: ["200gm matte paper"],
    desc: [
      "You will be surprised how you can still managed to see your small photos in this A5--sized ready-to-be-mailed postcard. You can easily mail and share your precious moments with your dear ones in a thoughtful way."
    ],
    images: [
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto/v1542708973/mondaybee/assets/Postcards.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1542708973/mondaybee/assets/Postcards.jpg",
        alt: "Mondaybee Postcards",
        width: 1080,
        height: 720
      },
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto/v1552375921/mondaybee/assets/PostcardBack.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1552375921/mondaybee/assets/PostcardBack.jpg",
        alt: "Back of a Postcard",
        width: 1080,
        height: 761
      }
    ],
    optionTitle: "quantity",
    options: [
      {
        id: "set12",
        name: "A set of 12 pcs",
        weight: 0.5
      },
      {
        id: "set20",
        name: "A set of 20 pcs",
        weight: 0.5
      }
    ]
  },
  printItYourself: {
    id: "printItYourself",
    title: "Softcopy",
    subtitle: "Print It Yourself",
    needShipping: false,
    single: true,
    thumbnail:
      "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_560/v1548234722/mondaybee/assets/print_it_yourself.jpg",
    shortDesc: "Create your own products",
    features: ["7000px x 5000px", "No watermark", "Send within 24 hours"],
    desc:
      "Have gift ideas other than what we offer? Or cannot wait to see the actual product? Buy a high resolution softcopy of your mosaic and be creative!",
    images: [
      {
        src:
          "https://res.cloudinary.com/nrator/image/upload/c_scale,f_auto,q_auto,w_1080/v1548234722/mondaybee/assets/print_it_yourself.jpg",
        thumb:
          "https://res.cloudinary.com/nrator/image/upload/c_fill,f_auto,h_90,q_auto,w_90/v1548234722/mondaybee/assets/print_it_yourself.jpg",
        alt: "Face Mounting",
        width: 1080,
        height: 763
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/data/products.js